/**
 * HOT GAMES CONFIG
 *
 * Sab games yahan directly hardcoded hain:
 * 1. Curated EVOASIA games (JetX, Sugar Ride, etc.)
 * 2. First 2 games from each provider in homeGamesConfig (EVOASIA, SPRIBE, EZUGI, PG, JL, JDB)
 *

 */

const HOT_GAMES_CONFIG = [


  // ── Curated EVOASIA Games ──────────────────────────────────────────────────
  { game_uid: '6f652ee587522116739db9ed5a8d529f', game_name: 'AviatorX', image: '/hotgames/aviator.png', supplier: 'SPRIBE' },
  { game_uid: 'ae632f32c3a1e6803f9a6fbec16be28e', game_name: 'Rummy', image: 'https://imgxcut.com/game/image/691e115dfe.png', supplier: 'JL' },
  { game_uid: '43e7df819bf57722a8917bb328640b30', game_name: 'Pool Rummy', image: 'https://imgxcut.com/game/image/5775a7b1dd.png', supplier: 'JL' },
  { game_uid: '55b4abd7ea22e78069c5a85b42da59b6', game_name: 'Sugar Ride',  image: '/hotgames/sugarride.png',  supplier: 'EVOASIA' },
  { game_uid: '1a6331cb34de981ca1e88592ef06c752', game_name: 'Fishing Club', image: '/hotgames/fishingclub.png', supplier: 'EVOASIA' },
  { game_uid: 'b5e693cdae7f862e5d0198550db0a413', game_name: 'Chicken Love', image: '/hotgames/chickenroad.png',  supplier: 'EVOASIA' },
  { game_uid: 'b3d92fb446a2829a06f828ec83f432f4', game_name: 'Mines',        image: '/hotgames/mines.png', supplier: 'EVOASIA' },
 { game_uid: '2e815f80a5a87b0255c130c00d95a71e', game_name: 'JetX', image: '/hotgames/jetx.png',supplier: 'EVOASIA' },
  { game_uid: '883580d090b1790a06fcfe8ea255272a', game_name: 'Horse Racing', image: '/hotgames/horseracing.png', supplier: 'EVOASIA' },
  { game_uid: 'e38dd01866d8e669cd032f00b8b2df8a', game_name: 'PlinkoX',      image: '/hotgames/plinko.png', supplier: 'EVOASIA' },
  
 // ── SPRIBE — first 2 from homeGamesConfig ─────────────────────────────────
  { game_uid: 'a04d1f3eb8ccec8a4823bdf18e3f0e84', game_name: 'Aviator', image: 'https://d3c3rwqla6qxaf.cloudfront.net/games-images/spribe/aviator/427x575/aviator.webp', supplier: 'SPRIBE' },
  { game_uid: '8a87aae7a3624d284306e9c6fe1b3e9c', game_name: 'Dice',    image: 'https://d3c3rwqla6qxaf.cloudfront.net/games-images/spribe/dice/427x575/dice.webp',       supplier: 'SPRIBE' },


  // ── EVOASIA — first 2 from homeGamesConfig ────────────────────────────────
  { game_uid: '394fe6a2cde24bc487767236cc6eccd6', game_name: 'XXXtreme Lightning Roulette', image: 'https://imgxcut.com/game/image/530fa3c16f.png',  supplier: 'EVOASIA' },
  { game_uid: '4a858d6b74c05260d3ea2762838798c7', game_name: 'Lightning Roulette',          image: 'https://imgxcut.com/game/image/775b6e861b.png',  supplier: 'EVOASIA' },

 
  // ── EZUGI — first 2 from homeGamesConfig ──────────────────────────────────
  { game_uid: '435b892a73bf466e0ad584d480e12143', game_name: 'Andar Bahar',       image: 'https://imgxcut.com/game/image/f403e7adec.png?_v=4,dpr=3,width=200', supplier: 'EZUGI' },
  { game_uid: 'e1b5650cd867be7719c15e7596aa7217', game_name: 'Bet on Teen Patti', image: 'https://imgxcut.com/game/image/76f25a7f74.png?_v=4,dpr=3,width=200', supplier: 'EZUGI' },

  // ── PGSoft — first 2 from homeGamesConfig ─────────────────────────────────
  { game_uid: '1189baca156e1bbbecc3b26651a63565', game_name: 'Mahjong Ways',   image: 'https://imgxcut.com/game/image/e767254e44.png?_v=4,dpr=3,width=200', supplier: 'PG' },
  { game_uid: 'ba2adf72179e1ead9e3dae8f0a7d4c07', game_name: 'Mahjong Ways 2', image: 'https://imgxcut.com/game/image/ea66cebab7.png?_v=4,dpr=3,width=200', supplier: 'PG' },

  // ── JiliGames — first 2 from homeGamesConfig ──────────────────────────────
  { game_uid: 'e794bf5717aca371152df192341fe68b', game_name: 'Royal Fishing',    image: 'https://imgxcut.com/game/image/9054d73bc5.png?_v=4,dpr=3,width=200', supplier: 'JL' },
  { game_uid: 'e333695bcff28acdbecc641ae6ee2b23', game_name: 'Bombing Fishing',  image: 'https://imgxcut.com/game/image/dd5fd0859d.png?_v=4,dpr=3,width=200', supplier: 'JL' },

  // ── JDB — first 2 from homeGamesConfig ────────────────────────────────────
  { game_uid: '3d97f2073a05873b428be0ff20df724c', game_name: 'Wealthway',   image: 'https://imgxcut.com/game/image/15599ea594.png', supplier: 'JDB' },
  { game_uid: '9341a18d096ad901ef77338998f29098', game_name: 'Dragon Soar', image: 'https://imgxcut.com/game/image/ed69a6ca93.png', supplier: 'JDB' },

];

export default HOT_GAMES_CONFIG;
